import { FC, Fragment } from "react";

import { leafletDashToMapLibreDashArray, MapConst } from "@ryde/shared";

import {
  TRAIL_ARROW_SYMBOL_SPACING_PX,
  TRAIL_LINE_WIDTH_PX,
} from "../route-block-maplibre.constants";
import { MapLibreGeoJsonLine } from "./maplibre-geojson-line";
import { ITrailSegment } from "./maplibre-tracking-route.models";

/**
 * The GPS trail's lines: each merged segment drawn twice, a wide dark shadow under a narrower coloured line, so
 * the trail stays readable over both light and dark tiles. Both share the segment's dash pattern and the same
 * `line-offset`, which is what keeps them registered on each other.
 */
export const MapLibreTrackingTrailLines: FC<{
  trailId: string;
  segments: ITrailSegment[];
  /** Below this zoom the direction arrows are skipped. Unset = always drawn. */
  arrowsMinZoom?: number;
}> = ({ trailId, segments, arrowsMinZoom }) => (
  <>
    {segments.map((segment, index) => {
      const segmentId = `${trailId}-seg-${index}`;

      return (
        <Fragment key={segmentId}>
          <MapLibreGeoJsonLine
            id={`${segmentId}-shadow`}
            feature={segment.feature}
            color={MapConst.GPS_TRAIL_SHADOW_COLOR}
            opacity={MapConst.GPS_TRAIL_SHADOW_OPACITY}
            lineWidth={MapConst.GPS_TRAIL_SHADOW_WEIGHT}
            dashArray={leafletDashToMapLibreDashArray(
              segment.dashArray,
              MapConst.GPS_TRAIL_SHADOW_WEIGHT,
            )}
            lineOffsetPx={MapConst.GPS_TRAIL_OFFSET_PX}
          />
          <MapLibreGeoJsonLine
            id={segmentId}
            feature={segment.feature}
            color={segment.lineColor}
            opacity={MapConst.GPS_TRAIL_OPACITY}
            lineWidth={TRAIL_LINE_WIDTH_PX}
            dashArray={leafletDashToMapLibreDashArray(
              segment.dashArray,
              TRAIL_LINE_WIDTH_PX,
            )}
            lineOffsetPx={MapConst.GPS_TRAIL_OFFSET_PX}
            withArrows
            arrowSpacingPx={TRAIL_ARROW_SYMBOL_SPACING_PX}
            arrowsMinZoom={arrowsMinZoom}
          />
        </Fragment>
      );
    })}
  </>
);
